import React from "react";
import moment from "moment";
import type { ColumnType } from "antd/es/table/interface";
import { DetailedReportEntry } from "../types";
import { formatMinutes } from "../utils";

const col = (
  title: string,
  key: string,
  render: (r: DetailedReportEntry) => React.ReactNode,
): ColumnType<DetailedReportEntry> => ({
  title,
  key,
  dataIndex: key,
  sorter: true,
  showSorterTooltip: false,
  render: (_: any, record: DetailedReportEntry) => render(record),
});

export const detailedColumns: ColumnType<DetailedReportEntry>[] = [
  {
    title: "Time Entry",
    key: "description",
    dataIndex: "description",
    sorter: true,
    showSorterTooltip: false,

    render: (_: any, record: DetailedReportEntry) => (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: record.projectColor || "#137AE9",
            flexShrink: 0,
            display: "inline-block",
          }}
        />
        <div style={{ minWidth: 0 }}>
          <span
            style={{ color: "#333", fontWeight: 500, wordBreak: "break-word" }}
          >
            {record.description || (
              <span style={{ color: "#bbb", fontStyle: "italic" }}>
                No description
              </span>
            )}
          </span>
          <div
            style={{
              fontSize: 12,
              color: record.projectColor || "#137AE9",
              fontWeight: 500,
            }}
          >
            {record.projectName}
            {record.clientName && (
              <span style={{ color: "#888", fontWeight: 400 }}>
                {" · "}
                {record.clientName}
              </span>
            )}
          </div>
        </div>
      </div>
    ),
  },
  {
    ...col("User", "user", (r) => (
      <span style={{ whiteSpace: "nowrap" }}>
        {r.firstName} {r.lastName}
      </span>
    )),
    width: 160,
  },
  {
    ...col("Time", "start", (r) => (
      <div style={{ whiteSpace: "nowrap" }}>
        <div style={{ fontWeight: 500 }}>
          {moment.utc(r.start).local().format("h:mmA")}
          {" – "}
          {moment.utc(r.end).local().format("h:mmA")}
        </div>
        <div style={{ fontSize: 11, color: "#8c8c8c" }}>
          {moment.utc(r.start).local().format("MM/DD/YYYY")}
        </div>
      </div>
    )),
    width: 200,
  },
  {
    title: "Duration",
    key: "timeSpan",
    dataIndex: "durationMinutes",
    sorter: true,
    showSorterTooltip: false,
    align: "right" as const,
    width: 110,
    render: (_: any, record: DetailedReportEntry) => (
      <span style={{ fontWeight: 700, fontVariantNumeric: "tabular-nums" }}>
        {formatMinutes(record.durationMinutes)}
      </span>
    ),
  },
];
